<template>
  <div class="container">
    <div class="column is-8 is-offset-2">

      <b-message v-if="isCanceled" type="is-warning" has-icon>
        中止されたイベントです。<br>
        参加できませんのでご注意ください。
      </b-message>

      <b-message v-if="isClosed" type="is-warning" has-icon>
        終了したイベントです。<br>
        参加できませんのでご注意ください。
      </b-message>

      <div class="card">
        <div class="card-content">

          <b-taglist>
            <b-tag v-if="isLogin && isOwner" type="is-primary">あなたが主催者です</b-tag>
          </b-taglist>

          <p class="title">
            <b-icon icon="calendar-month" pack="mdi" size="is-medium"></b-icon>
            {{ start.seconds | moment("YYYY年M月D日(ddd)") }}
          </p>
          <p class="title">
            <b-icon icon="clock-outline" pack="mdi" size="is-medium"></b-icon>
            {{ start.seconds | moment("k:mm") }}-{{ end.seconds | moment("k:mm") }}
          </p>
        </div>
        <div class="card-content">
          <p v-if="!isEdittingRecruitment" class="subtitle buttons">
            <span>募集 <strong>{{recruitment}}</strong> 名</span>
            <span v-if="entryCount">
              <b-icon icon="slash-forward" pack="mdi"></b-icon>
              <b-icon icon="account-check-outline" pack="mdi"></b-icon>
              <span> <strong>{{entryCount}}</strong> 名</span>
            </span>
            <span class="edit-button">
              <b-button v-if="isOwner && !isClosed && !isCanceled" type="is-text" v-on:click="editRecruitment">
                <b-icon
                  type="is-primary"
                  size="is-large"
                  pack="mdi"
                  icon="pencil-circle">
                </b-icon>
              </b-button>
            </span>
          </p>
          <div v-else class="column is-half">
            <b-field label="募集人数">
              <b-numberinput
                v-model="recruitment"
                min="1"
                required
                type="is-light">
              </b-numberinput>
              <span class="editDone-button">
                <b-button v-on:click="doneEditRecruitment"
                  type="is-primary"
                  pack="mdi"
                  icon-left="check">
                  Save
                </b-button>
              </span>
            </b-field>
          </div>

          <a :href="googlemap_link" target="_blank">
            <p class="subtitle">
              <b-icon pack="fas" icon="map-marker-alt" size="" type="is-primary"></b-icon>
              {{courtName}}
            </p>
          </a>
        </div>

        <div class="card-image">
          <figure class="image is-16by9">
            <a :href="googlemap_link" target="_blank">
              <img :src='googlemap_image_url'/>
            </a>
          </figure>
        </div>

        <div class="card-content">
          <div v-if="!isEdittingMemo" class="content buttons">
            {{memo}}
            <span class="edit-button">
              <b-button v-if="isOwner && !isClosed && !isCanceled" type="is-text" v-on:click="editMemo">
                <b-icon
                  type="is-primary"
                  size="is-large"
                  pack="mdi"
                  icon="pencil-circle">
                </b-icon>
              </b-button>
            </span>
          </div>
          <div v-else class="content">
            <b-field label="メモ">
              <b-input
                v-model="memo"
                placeholder="レベルや金額など参加者に伝えたいことをお書きください。"
                maxlength="500"
                required
                type="textarea">
              </b-input>
            </b-field>
            <span class="editDone-button">
              <b-button v-on:click="doneEditMemo"
                type="is-primary"
                pack="mdi"
                icon-left="check">
                Save
              </b-button>
            </span>
          </div>

          <div class="content level">
            <div class="level-left">
              <span class="level-item">主催者</span>
              <span class="level-item">
                <b-icon icon="account-circle" pack="mdi"></b-icon>
              </span>
              <span class="level-item">{{ownerName}}</span>
            </div>
          </div>
        </div>

        <footer class="card-footer">
          <div class="buttons">
            <div class="card-footer-item">
              <b-button v-if="isClosed" disabled>
                イベント終了
              </b-button>
              <div v-else>
                <div v-if="isEntry">
                  <b-button disabled icon-left="check" icon-pack="mdi">
                    申込済
                  </b-button>
                  <b-button v-on:click="doEntryCancel" type="is-text">
                    キャンセルする
                  </b-button>
                </div>
                <div v-else>
                  <div v-if="isOwner" >
                    <b-collapse :open="false" aria-id="contentIdForEntryList">
                      <div
                        class="button is-light"
                        slot="trigger"
                        slot-scope="props"
                        role="button"
                        aria-controls="contentIdForA11y1">
                        <span>参加者リスト</span>
                        <b-icon
                          :icon="props.open ? 'caret-down' : 'caret-up'" pack="fas">
                        </b-icon>
                      </div>
                      <ol class="card-content">
                        <li v-for="(doc, index) of entryData"
                          :key=index
                          :open="isOpen == index"
                          @open="isOpen = index">
                          <span>
                            <strong>{{ doc.data().userName }}</strong> さん
                            {{ doc.data().createdAt.seconds | moment("YYYY年M月D日(ddd) H:m") }} 申込
                          </span>
                        </li>
                      </ol>
                    </b-collapse>
                    <b-button v-if="!isCanceled" v-on:click="doEventCancel" type="is-danger" icon-left="cancel">
                      中止する
                    </b-button>
                  </div>
                  <div v-else>
                    <b-button v-if="isCanceled" disabled>
                      中止
                    </b-button>
                    <div v-else>
                      <b-button v-if="isLogin" v-on:click="confirmeRequest" type="is-primary">
                        参加する
                      </b-button>
                      <b-dropdown v-else position="is-top-right" aria-role="list">
                        <button class="button is-primary" slot="trigger">
                          <span>参加する</span>
                          <b-icon icon="menu-down"></b-icon>
                        </button>
                        <b-dropdown-item
                          aria-role="listitem"
                          :focusable="false"
                          custom
                          >
                          <div class="modal-card">
                            <p>イベント申し込みにはログインが必要です。最上部右の「ログイン」ボタンを押してください。(はじめてアカウント登録される方もアカウント登録と同時にログインができます。)</p>
                          </div>
                        </b-dropdown-item>
                      </b-dropdown>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </footer>
      </div>
      <shareButtons :title="title" />
    </div>
  </div>
</template>

<script>
  import firebase from '@/firebase/firebase'
  var db = firebase.firestore();
  import shareButtons from "@/components/ShareButtons"

  export default {
    name: 'event-detail',
    props: ['currentUser', 'isLogin'],
    components: {
      shareButtons
    },
    data () {
      return {
        start: "",
        end: "",
        courtName: "",
        recruitment: 0,
        ownerName: "",
        ownerID: "",
        isOwner: false,
        memo: "",
        point: "",
        googlemap_image_url: "",
        googlemap_link: "",
        isClosed: false,
        isEntry: false,
        eventId: "",
        entryId: "",
        entryCount: null,
        entryData: [],
        isOpen: 0,
        isCanceled: false,
        title: '',
        isEdittingRecruitment: false,
        isEdittingMemo: false,
        oldRecruitment: null,
        oldMemo: null
      }
    },
    mounted() {
      db.collection("events").doc(this.$route.params.event).get()
      .then(doc => {
        if (!doc.exists) {
          console.log('No such document!');
        } else {
          this.eventId = this.$route.params.event
          this.start = doc.data().start
          this.end = doc.data().end
          this.courtName = doc.data().courtName
          this.recruitment = doc.data().recruitment
          this.ownerName = doc.data().ownerName
          this.ownerID = doc.data().ownerID
          this.memo = doc.data().memo
          this.point = doc.data().point
          this.googlemap_image_url = 'https://maps.googleapis.com/maps/api/staticmap?center=' + this.point.latitude + ',' + this.point.longitude + '&zoom=12&size=640x360&markers=' + this.point.latitude + ',' + this.point.longitude + '&key=' + this.$GoogleMapKey
          this.googlemap_link = 'https://www.google.com/maps/search/?api=1&query=' + this.courtName + '&center=' + this.point.latitude + ',' + this.point.longitude + '&zoom=14&mapmode=standard'

          var now = Math.floor(new Date() / 1000); // 現在時刻 UnixTime
          if (this.end.seconds < now) {
            this.isClosed = true
          } else {
            this.isClosed = false
          }

          if (doc.data().canceled) {
            this.isCanceled = true
          } else {
            this.isCanceled = false
          }

          // Entry Count and Entry List
          db.collection("entries")
            .where('eventID', '==', this.eventId)
            .get().then(snapshot => {
              if(snapshot.empty) {
                console.log('No entry count.')
                this.entryCount = null
              } else {
                this.entryCount = snapshot.size
                console.log('entry count:', this.entryCount)
                snapshot.forEach(doc => {
                  this.entryData.push(doc)
                  console.log(this.entryData)
                })
              }
          })
          .catch(err => {
            console.log('Error getting documents', err);
          })
        }
      })
      .catch(err => {
        console.log('Error getting document', err);
      })
    },
    beforeUpdate() {
      // cheking Owner of this event
      if(this.isLogin) {
        if(this.ownerID == this.currentUser.uid) {
          this.isOwner = true
          console.log('isOwner is true.')
        } else {
          this.isOwner = false
          console.log('isOwner is false.')
        }

        // isEntry
        db.collection("entries")
          .where('eventID', '==', this.eventId)
          .where('userID', '==', this.currentUser.uid)
          .limit(1)
          .get().then(snapshot => {
            if(snapshot.empty) {
              console.log('No matching entry.')
              this.isEntry = false
            } else {
              snapshot.forEach(doc => {
                this.entryId = doc.id
                this.isEntry = true
              })
            }
        })
        .catch(err => {
          console.log('Error getting documents', err);
        })
      } else {
        this.isOwner = false
        console.log('isOwner is false.')
      }
    },
    methods: {
      confirmeRequest: function() {
        if(this.isLogin) {
          var confirmEntry = confirm('このイベントに申し込みますか？');

          if(confirmEntry) {
            if(this.isLogin) {
              // Add a new document with a generated id.
              db.collection("entries").add({
                eventID: this.eventId,
                userID: this.currentUser.uid,
                userName: this.currentUser.displayName,
                createdAt: firebase.firestore.FieldValue.serverTimestamp()
              })
              .then(docRef => {
                this.$data.isEntry = true
                this.$data.entryId = docRef.id
                console.log("Entry written with ID: ", docRef.id)
              })
              .catch(function(error) {
                console.error("Error adding document: ", error);
              });
            }
          } else {
            console.log('You need login or signup.')
          }
        }
      },
      doEntryCancel: function() {
        var confirmCancel = confirm('参加申込をキャンセルします。よろしいですか？');

        if(confirmCancel) {
          if(this.isLogin) {
            db.collection("entries").doc(this.entryId).delete()
              .then(() => {
                this.$data.isEntry = false
                this.$data.entryId = ""
                console.log("Document successfully deleted!")
              })
              .catch(function(error) {
                console.error("Error removing document: ", error);
              })
          }
        } else {
          console.log('did not cancel.')
        }
      },
      doEventCancel: function() {
        var confirmEventCancel = confirm('このイベントを中止します。よろしいですか？');

        if(confirmEventCancel) {
          if(this.isLogin) {
            // update a event for canceled.
            db.collection("events").doc(this.eventId).update({
              canceled: true
            })
            .then(() => {
              this.$data.isCanceled = true
              console.log("Event canceled ID: ", this.$data.eventId)
            })
            .catch(function(error) {
              console.error("Error updating document: ", error);
            });
          }
        } else {
          console.log('did not cancel.')
        }
      },
      editRecruitment: function() {
        this.oldRecruitment = this.recruitment
        this.isEdittingRecruitment = true
      },
      doneEditRecruitment: function() {
        if(this.recruitment != this.oldRecruitment) {
          db.collection("events").doc(this.eventId).update({
            recruitment: this.recruitment
          })
          .then(() => {
            this.isEdittingRecruitment = false
            console.log("Event updated recruitment: ", this.$data.eventId)
          })
          .catch(function(error) {
            console.error("Error updating document: ", error);
          });
        }
        else {
          this.isEdittingRecruitment = false
        }
      },
      editMemo: function() {
        this.oldMemo = this.memo
        this.isEdittingMemo = true
      },
      doneEditMemo: function() {
        if(this.memo != this.oldMemo) {
          db.collection("events").doc(this.eventId).update({
            memo: this.memo
          })
          .then(() => {
            this.isEdittingMemo = false
            console.log("Event updated memo: ", this.$data.eventId)
          })
          .catch(function(error) {
            console.error("Error updating document: ", error);
          });
        }
        else {
          this.isEdittingMemo = false
        }
      }
    },
    metaInfo() {
      const day = this.$moment.unix(this.start.seconds).format("YYYY/MM/DD")
      const time = this.$moment.unix(this.start.seconds).format("k:mm")
      const meta_title = day + ' ' + time + '- @ ' + this.courtName
      this.title = meta_title
      const meta_description = "フットサルメンバー募集！！ " + this.memo
      return {
        title: meta_title,
        titleTemplate: '%s | FutsalMet',
        meta: [
          { name: 'description', content: meta_description },
          { name: 'robots', content: 'index, follow' },
          // Faebook OGP
          { property: 'og:type', content: 'website' },
          { property: 'og:site_name', content: 'Futsal Met' },
          { property: 'og:url', content: location.href },
          { property: 'og:title', content: meta_title },
          { property: 'og:description', content: meta_description },
          { property: 'og:image', content: this.googlemap_image_url },
          // Twitter card
          { name: 'twitter:card', content: 'summary_large_image' }
        ]
      }
    }
  }
</script>

<style>
.edit-button {
  margin-top: 20px;
  margin-left: 20px;
  margin-bottom: 10px;
}
.editDone-button {
  margin-left: 20px;
}
.card-content {
  white-space: pre-wrap !important;
}
</style>
